(function () {
    
    var cakeCustomiserPage = function () {

        var vm = kendo.observable({
            includeBirthdayKit: true,
            includePersonalMessage: false,
            candleType: "Default - 1 x Big Candle",
            isEnabled: function () {
                return this.get('enable') == "true"
            },
            disableBirthdayKit: function () {
                return this.get('includeBirthdayKit') == false;
            },
            isFireworksSelected: function () {
                return this.get("candleType") == "Fireworks";
            },
            isBirthdaySelected: function () {
                return this.get("candleType") == "Birthday";
            },
            ispersonalMessageChecked: function () {
                return this.get('includePersonalMessage') == true;
            },
            isBirthdayKitChecked: function (){
              return this.get('includeBirthdayKit') == true;
            }          
        });
        vm.set('enable', "true")
        vm.bind('change', function (e) {

        });
        kendo.bind($('#cake-customizer'), vm);
    }

    $(document).ready(function () {

        if ($('#cake-customizer').length > 0) {
            cakeCustomiserPage();
        };
    })
})();